import styled from 'styled-components'

export const ModalDataContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background: red;

    div {
        flex-direction: column;

        h1 {
            align-self: flex-start;
        }
    }
`
